import logo from './logo.svg';
import './App.css';
import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import {Navbar , Container , Nav , Brand } from 'react-bootstrap'
// import { BrowserRouter as Router ,Link, Route } from 'react-router-dom';
// import Navbar1 from './NavBar';
import Home from './Home';

function App() {
  return (
    <div className="App">
      {/* <Router>
        <Navbar bg="dark" variant="dark">
    <Container>
    <Navbar.Brand href="#home">Navbar</Navbar.Brand>
    <Nav className="me-auto">
      <Nav.Link href="#home"><Link to="/home">Home</Link></Nav.Link>
      <Nav.Link href="#features"><Link to="/about">ABOUT</Link></Nav.Link>
      <Nav.Link href="#pricing">Pricing</Nav.Link>
    </Nav>
    </Container>
  </Navbar>
      <Route path="/home"><Home/></Route>
      <Route path="/about"><About/></Route>
      </Router> */}
      {/* <Navbar1/> */}
      
    </div>
  );

 


}


export default App;
